import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { TableLoader, TableModel } from "../../components/tableLoader";
export { FileView };

function FileView({ path, icon, title, dir = "" }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const subdir = searchParams.get("dir") ?? "";
  const loader = {
    title: title,
    icon: icon,
    request: {
      method: "post",
      path: path,
      data: {
        dir_path: subdir ? dir + "/" + subdir.replace(/^[./]+/, "") : dir,
      },
    },
    parser: (response) => createFileViewModel({ subdir, response, onClick, onUp }),
    key: dir + "/" + subdir,
  };

  return <TableLoader {...loader} />;

  function onClick(file) {
    const name = file.name;
    searchParams.set("dir", subdir ? subdir + "/" + name : name);
    setSearchParams(searchParams);
  }

  function onUp() {
    const path = subdir.split("/");
    path.pop();
    searchParams.set("dir", path.join("/"));
    setSearchParams(searchParams);
  }
}

function createFileViewModel({ subdir, response, onClick, onUp }) {
  const table = new TableModel({
    columns: [
      { field: "file", headerName: "Имя", type: "file", sortable: true },
      { field: "preview", headerName: "Просмотр", type: "img" },
      { field: "length", headerName: "Размер (МБ)", type: "number" },
      { field: "update_date", headerName: "Дата изменения", type: "date" },
    ],
    rows: [],
  });

  if (subdir)
    table.rows.push({
      file: {
        name: "..",
        mime_type: "inode/directory",
        href: "#",
        onClick: onUp,
      },
      preview: null,
      length: "Наверх",
      update_date: "",
    });
  if (Array.isArray(response.rows)) {
    for (const row of response.rows) {
      if ("inode/directory" === row.mime_type) {
        table.rows.push({
          file: {
            mime_type: row.mime_type,
            name: row.name,
            href: "#",
            onClick,
          },
          preview: null,
          length: row.length,
          update_date: row.update_date,
        });
      } else {
        const preview = row.has_preview
          ? {
              name: row.name,
              src: row.url_preview,
              href: row.url,
              target: "_blank",
            }
          : null;

        table.rows.push({
          file: {
            mime_type: row.mime_type,
            name: row.name,
            href: row.url,
            download: true,
            target: "_blank",
          },
          preview,
          length: row.length,
          update_date: row.update_date,
        });
      }
    }
  }

  return table;
}
